export default __webpack_public_path__ + "static/media/men.47e6c467.jpg";